import { SOURCES_TEXT } from "app/components/widget/widget-types/WidgetConstants";
import type { ICountryObject } from "app/services/CountryService";
import CountryService from "app/services/CountryService";
import {
    PngHeaderContainer,
    PngHeaderContentContainer,
    Text,
} from "app/pages/website-analysis/TrafficAndEngagement/Components/StyledComponents";
import { colorsPalettes } from "@similarweb/styles";

type Props = {
    metricTitle: string;
    durations: string | string[];
    webSource: keyof (typeof SOURCES_TEXT)["websites"];
    country: number;
};

export const PngHeader = ({ metricTitle, durations, webSource, country }: Props) => {
    const textColor = colorsPalettes.carbon[500];
    const webSourceDisplayName = SOURCES_TEXT.websites[webSource];
    const countryObject: ICountryObject = CountryService.getCountryById(country);
    return (
        <PngHeaderContainer>
            <PngHeaderContentContainer>
                <Text
                    color={textColor}
                    size={28}
                    opacity={0.8}
                >
                    {metricTitle}
                </Text>
                <Text
                    color={textColor}
                    size={16}
                    opacity={0.8}
                >{`${durations} | ${countryObject.text} | ${webSourceDisplayName}`}</Text>
            </PngHeaderContentContainer>
        </PngHeaderContainer>
    );
};
